import type { MenuLinksProps } from "./interfaces";
import { SubLinksBox } from "./LinkSubItems";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

export const MenuLinks = ({ menuLinks }: MenuLinksProps) => {
  return (
    <ul className="flex content-center justify-center items-center px-1 lg:px-4">
      {menuLinks.map((link) => (
        <li className="relative group" key={link.name}>
          {link.link && (
            <a
              href={link.link}
              className="flex items-center justify-center p-2 mb-1 mt-1 rounded-full font-medium cursor-pointer lg:px-4 text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-primary-lighter"
            >
              <div className="flex flex-col items-center justify-center text-center">
                <p>{link.name}</p>
              </div>
            </a>
          )}
          {link.subLinks && link.subLinks.length > 0 && (
            <>
              <div className="flex align-middle justify-center p-2 pt-2 pb-2 mb-1 mt-1 rounded-full font-medium cursor-pointer lg:px-4 text-gray-700 hover:text-primary dark:text-gray-300 dark:hover:text-primary-lighter">
                {link.name}
                <span className="group-hover:rotate-180 ml-2 mt-1 inline-block w-5 h-5 transform transition-transform duration-200 flex-shrink-0">
                  <ChevronDownIcon />
                </span>
              </div>
              <div className="hidden group-hover:block">
                <SubLinksBox subLinks={link.subLinks} extraLinks={link.extraLinks} />
              </div>
            </>
          )}
        </li>
      ))}
    </ul>
  );
};
